import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getBarangjasaContent = createAsyncThunk('/barangjasa/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listGoodsServices/${userId}`, {})
    return response.data;
})

export const barangjasaSlice = createSlice({
    name: 'barangjasa',
    initialState: {
        isLoading: false,
        barangjasa : []
    },
    reducers: {
        addNewBarangjasa: (state, action) => {
            let {newBarangjasaObj} = action.payload
            state.barangjasa = [...state.barangjasa, newBarangjasaObj]
        },

        deleteBarangjasa: (state, action) => {
            let {index} = action.payload
            state.barangjasa.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getBarangjasaContent.pending]: state => {
			state.isLoading = true
		},
        [getBarangjasaContent.fulfilled]: (state, action) => {
            state.barangjasa = action.payload.data
			state.isLoading = false
		},
        [getBarangjasaContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getBarangjasaContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getBarangjasaContent.fulfilled, (state, action) => {
            state.barangjasa = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getBarangjasaContent.rejected, (state) => {
            state.isLoading = false;
          });
      },
})

export const { addNewBarangjasa, deleteBarangjasa } = barangjasaSlice.actions

export default barangjasaSlice.reducer